module.exports = __webpack_public_path__ + "img/email-icon.3544ce24.png";